import { InitialFilterActions, InitialFilterActionsType } from './InitialFilterActions';

export type InitialFilterState = {
  years: readonly number[];
  models: readonly string[];
  trims: readonly string[];
  brands: readonly string[];
  exteriorColor: readonly string[];
  interiorColor: readonly string[];
  ageDays: { min: number; max: number };
  mileage: { min: number; max: number };
  price: { min: number; max: number };
};

export const initialFilterState: InitialFilterState = {
  years: [],
  models: [],
  trims: [],
  brands: [],
  exteriorColor: [],
  interiorColor: [],
  ageDays: {
    min: -1,
    max: -1,
  },
  mileage: {
    min: -1,
    max: -1,
  },
  price: {
    min: -1,
    max: -1,
  },
};

export const initialFilterReducer = (
  state: InitialFilterState = initialFilterState,
  action: InitialFilterActions,
): InitialFilterState => {
  switch (action.type) {
    case InitialFilterActionsType.SET_YEARS:
      return {
        ...state,
        years: action.payload,
      };
    case InitialFilterActionsType.SET_BRANDS:
      return {
        ...state,
        brands: action.payload,
      };
    case InitialFilterActionsType.SET_MODELS:
      return {
        ...state,
        models: action.payload,
      };
    case InitialFilterActionsType.SET_TRIMS:
      return {
        ...state,
        trims: action.payload,
      };
    case InitialFilterActionsType.SET_EXT_COLOR:
      return {
        ...state,
        exteriorColor: action.payload,
      };
    case InitialFilterActionsType.SET_INT_COLOR:
      return {
        ...state,
        interiorColor: action.payload,
      };
    case InitialFilterActionsType.SET_AGE_DAYS:
      return {
        ...state,
        ageDays: action.payload,
      };
    case InitialFilterActionsType.SET_MILEAGE:
      return {
        ...state,
        mileage: action.payload,
      };
    case InitialFilterActionsType.SET_PRICE:
      return {
        ...state,
        price: action.payload,
      };
    case InitialFilterActionsType.RESET_FILTER:
      return {
        ...initialFilterState,
      };
    default:
      return state;
  }
};
